import { render, staticRenderFns } from "./DhcpReservations.vue?vue&type=template&id=1d803601&"
import script from "./DhcpReservations.vue?vue&type=script&lang=js&"
export * from "./DhcpReservations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports